import { modules } from "../gameEngine";
import requireComponent = cc._decorator.requireComponent;

const {ccclass, property, menu} = cc._decorator;

@ccclass
@menu("框架组件/节点流畅辅助")
export default class comFluency extends cc.Component {

    @property()
    libCount: number = 1000;
    @property()
    onceCount: number = 10;
    @property()
    showTime: number = 1;
    @property()
    maxOpacity: number = 10;
    @property()
    minTick: number = 1;

    private m_loaded: number = 0;

    private m_lastPos: cc.Vec2;

    private m_lastShowNodes: cc.Node[];
    private m_nodeList: cc.Node[]

    //
    protected onLoad() {
        this.m_lastShowNodes = [];
        this.m_nodeList = [];
    }

    protected start() {
        this.m_lastPos = this.node.getPosition().clone();
    }

    protected isLoaded() {
        return this.m_loaded >= this.libCount;
    }

    protected loadOnce() {
        const sp = this.node.getComponent(cc.Sprite);
        const la = this.node.getComponent(cc.Label);
        for (let i = 0; i < this.onceCount; i++) {
            const node = new cc.Node();
            node.group = "Water";
            if (sp) {
                node.setContentSize(this.node.getContentSize());
                node.addComponent(cc.Sprite).spriteFrame = sp.spriteFrame;
            }
            if (la) {
                node.addComponent(cc.Label).string = la.string;
            }
            this.node.parent.addChild(node);
            this.m_nodeList.push(node);
            node.active = false;
            //
            this.m_loaded++;
        }
        if (this.isLoaded()) {
            console.log('启动残影');
            modules().uiControlModule.showMessageBox('启动残影');
        }
    }

    getReallyPos(): cc.Vec2 {
        const pos = this.node.getPosition().clone();
        let p = this.node.parent;
        while (p.getComponent(cc.Canvas) == null) {
            pos.x += p.x;
            pos.y += p.y;
            p = p.parent;
        }
        return pos;
    }

    setReallyPos(node: cc.Node, pos: cc.Vec2) {
        const v2 = cc.v2(0, 0);
        let p = this.node.parent;
        while (p.getComponent(cc.Canvas) == null) {
            v2.x += p.x;
            v2.y += p.y;
            p = p.parent;
        }
        return cc.v2(pos.x - v2.x, pos.y - v2.y);
    }

    protected onShowFluency(dt: number) {
        //已经切换位置
        if (this.m_lastPos) {
            //上一帧的
            for (let i = 0; i < this.m_lastShowNodes.length; i++) {
                const node = this.m_lastShowNodes[i];
                //看不见就回收
                if (node['showTime'] > this.showTime) {
                    this.m_lastShowNodes.splice(i, 1);
                    i--;
                    node.active = false;
                    this.m_nodeList.push(node);
                } else {
                    node['showTime'] += dt;
                }
            }
            //
            const currPos = this.node.getPosition().clone();
            const srcPos = this.m_lastPos.clone();
            const maxX = Math.abs(currPos.x - srcPos.x);
            const maxY = Math.abs(currPos.y - srcPos.y);
            const max = Math.max(maxX, maxY) / this.minTick;
            if (max == 0) {
                this.node.opacity = 255;
                return;
            }
            const xOne = maxX / max * this.minTick;
            const yOne = maxY / max * this.minTick;
            //分配透明度
            let haveCount = this.m_lastShowNodes.length;
            let all = haveCount + max;
            const maxOpacity = this.maxOpacity;//0.016 / this.showTime * 64;//1 / Math.max(Math.min(this.node.width, this.node.height) * 0.5, 1) * 255;
            let haveOpacity = maxOpacity * (all > 0 ? haveCount / all : 0);
            let lastOpacity = maxOpacity - haveOpacity;
            // console.log('几个', max, xOne, yOne);
            // console.log('透明度', haveOpacity, lastOpacity);
            //有的
            let str = '';
            for (let i = 0; i < haveCount; i++) {
                this.m_lastShowNodes[i].opacity = (i + 1) / haveCount * haveOpacity;
                this.m_lastShowNodes[i].zIndex -= max;
                str += `${this.m_lastShowNodes[i].zIndex},`;
            }

            for (let i = 0; i < max; i++) {
                let x = currPos.x > srcPos.x ? srcPos.x + i * xOne : srcPos.x - i * xOne;
                let y = currPos.y > srcPos.y ? srcPos.y + i * yOne : srcPos.y - i * yOne;
                const node = this.m_nodeList.shift();
                if (node) {
                    node['showTime'] = 0;
                    this.m_lastShowNodes.push(node);
                    node.active = true;
                    node.zIndex = -max + i - 1;
                    node.opacity = haveOpacity + (i + 1) / max * lastOpacity;
                    node.color = this.node.color;
                    node.setPosition(x, y);
                    str += `${node.zIndex},`;
                }
            }
            this.node.opacity = max;

        }
        this.m_lastPos = this.node.getPosition().clone();
    }

    protected update(dt: number) {
        //
        if (!this.isLoaded()) {
            this.loadOnce();
        } else {
            this.onShowFluency(dt);
        }
    }
}


























